import { toRem, toRems } from 'helpers/theme'

/* eslint-disable quote-props */
const style = ({ theme }) => ({
    background: theme.colors.blueMidAlt,
    marginBottom: toRem(15),
    borderRadius: 4,

    '& .question-box': {
        padding: toRem(20),
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        color: theme.colors.goldDark,
        position: 'relative',

        [theme.breakpoints.up('md')]: {
            padding: toRems([30, 40]),
            fontSize: toRem(24)
        },

        '& .block-control': {
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            textIndent: -9999,
            cursor: 'pointer'
        },

        '& .question': {
            maxWidth: '85%'
        },

        '& .controls': {
            width: 17,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',

            [theme.breakpoints.up('md')]: {
                width: 20
            }
        }
    },

    '& .answer-box': {
        padding: toRems([0, 20, 30, 20]),
        fontSize: toRem(14),

        [theme.breakpoints.up('md')]: {
            fontSize: toRem(20),
            padding: toRems([0, 40, 50, 40])
        }
    }
})

export default style
